export default __webpack_public_path__ + "static/media/aleppo.13d06861.jpg";